import React from "react";
import classNames from "classnames";


interface SortButtonProps {
    className?: string;
    active?: boolean;
    order?: "asc" | "desc";
    onClick?: () => void;
    children: React.ReactNode;
}

const SortButton: React.FC<SortButtonProps> = (props) => {
    const {
        className: propsClassName,
        order = "asc",
        active = true,
        onClick,
        children
    } = props;

    return (
        <button className={classNames("group flex items-center gap-1", propsClassName)}
                onClick={onClick}
        >
            {children}
            <svg className={classNames(
                     "size-2.5 inline-block stroke-current",
                     !active && "hidden group-hover:inline-block group-hover:opacity-50 group-focus:inline-block group-focus:opacity-50",
                     order === "asc" ? "rotate-0" : "rotate-180"
                 )}
                 width="8" height="12" viewBox="0 0 8 12"
                 fill="none" xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M3.85715 1V11" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.71429 3.85714L3.85715 1" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M1 3.85714L3.85714 1" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>
    );
};
export default SortButton;
